import { Injectable } from "@angular/core";

import {HttpClient,HttpHeaders} from "@angular/common/http"
import { ConfigService } from "../shared/utils/config.service";
import { map } from "rxjs";


@Injectable()
export class MailingService {

    baseUrl: string = '';

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.baseUrl = configService.getApiURI();
    };

    getMailing(mail: string) {
        return this.http.get(this.baseUrl + '/mailing/' + mail)
            .pipe(map((res:any) => res.json()));

    }

    createMailing(mail: string) {
        return this.http.post(this.baseUrl + '/mailing/' + mail, mail)
            .pipe(map((res:any) => res.json()));

    }
}